import { Typo } from '@/ui/component';
import { getSharedData } from '@/ui/util';
import { CustomEventWithDetail, html, on, View } from 'rune-ts';
import klass from './Tabs.module.scss';

export interface Tab {
  index: string;
  label: string;
  active: boolean;
}

export interface TabsData {
  tabs: Tab[];
}

export class TabClickEvent extends CustomEventWithDetail<Tab> {}

export class Tabs extends View<TabsData> {
  override template() {
    const { theme } = getSharedData(this);

    return html`<div class="${klass.tabs}">
      ${this.data.tabs.map(
        (tab) =>
          html`<button class="${klass.tab}" data-active="${tab.active}" data-index="${tab.index}">
            ${new Typo({ text: tab.label }, { typo: 'p1', weight: theme === 'Marpple' ? 'medium' : 'bold' })}
          </button>`,
      )}
    </div> `;
  }

  @on('click', `.${klass.tab}`)
  private _tabClickHandler(e: MouseEvent) {
    const button = e.currentTarget as HTMLButtonElement;
    const tab = this.data.tabs.find((tab) => tab.index === button.dataset.index);

    if (tab) {
      this.dispatchEvent(TabClickEvent, { bubbles: true, detail: tab });
    }
  }
}
